/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FormatPercentage = {
    format: FormatPercentage.format;
    decimals: number;
};
export namespace FormatPercentage {
    export enum format {
        PERCENTAGE = 'percentage',
    }
}

